// extracted by mini-css-extract-plugin
export var container = "MarkdownTemplate-module--container--a42cf";
export var copyButton = "MarkdownTemplate-module--copyButton--c31ad";